import coreCameraProps, { coreCameraPropsMetric } from 'helpers/cameras/coreCameraProps'
import calculatedCameraProps from 'helpers/cameras/calculatedCameraProps'
import clamp from 'ramda/src/clamp'

/** Used in tests and to initialize a camera */
export default function initialCameraProps(id = 1, isMetric = false, distance) {
  const cameraProps = isMetric ? coreCameraPropsMetric() : coreCameraProps()

  return {
    ...calculatedCameraProps(Object.assign(
      {},
      cameraProps,
      !!distance && { distance: clamp(1, cameraProps.distance, distance * (isMetric ? 1 : 3.281)) }
    )),
    active: true,
    name: `Camera ${id}`,
    locked: false,
    id
  }
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/initialCameraProps.js